export default "__VITE_ASSET__Gnr9cKdw__"